"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const HyphenIcon = ({
  color,
  title,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  width: "18",
  height: "16",
  viewBox: "0 0 18 16",
  xmlns: "http://www.w3.org/2000/svg",
  fillRule: "evenodd",
  clipRule: "evenodd",
  strokeLinejoin: "round",
  strokeMiterlimit: 2,
  ...otherProps,
  children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    children: title
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M1.092 9.001a1 1 0 01-.117-1.993l.117-.007h15.816c.076 0 .214-.009.284.007.447.1.716.516.716.993a1 1 0 01-.883.994l-.117.006H1.092z",
    fill: color,
    fillRule: "nonzero"
  })]
});

HyphenIcon.defaultProps = {
  color: 'currentColor',
  title: undefined
};
var _default = HyphenIcon;
exports.default = _default;